import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = getters.getDefaultState();

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
